import { AnimType, PresetSubtype } from '../constants';

// 更新动画方向同时也需要更新 animEffect 字段的动画
export const animEffectUpdateList = [
    AnimType.EntrBlinds,
    AnimType.ExitBlinds,
    AnimType.CutIn,
    AnimType.CutOut,
    AnimType.EntrCheckerboard,
    AnimType.ExitCheckerboard,
    AnimType.EntrRandomBars,
    AnimType.ExitRandomBars,
    AnimType.EntrShapeCircle,
    AnimType.ExitShapeCircle,
    AnimType.EntrShapeBox,
    AnimType.ExitShapeBox,
    AnimType.EntrShapeDiamond,
    AnimType.ExitShapeDiamond,
    AnimType.EntrShapePlus,
    AnimType.ExitShapePlus,
    AnimType.EntrWheel,
    AnimType.ExitWheel,
    AnimType.EntrSplit,
    AnimType.ExitSplit,
    AnimType.EntrStrips,
    AnimType.ExitStrips,
    AnimType.EntrWipe,
    AnimType.ExitWipe,
];

export const presetSubTypeAnimEffectFilterMap: Partial<Record<AnimType, Partial<Record<PresetSubtype, string>>>> = {
    [AnimType.EntrBlinds]: {
        [PresetSubtype.Across]: 'blinds(horizontal)',
        [PresetSubtype.Vertical]: 'blinds(vertical)',
    },
    [AnimType.ExitBlinds]: {
        [PresetSubtype.Across]: 'blinds(horizontal)',
        [PresetSubtype.Vertical]: 'blinds(vertical)',
    },

    [AnimType.EntrCheckerboard]: {
        [PresetSubtype.Across]: 'checkerboard(across)',
        [PresetSubtype.Vertical]: 'checkerboard(down)',
    },
    [AnimType.ExitCheckerboard]: {
        [PresetSubtype.Across]: 'checkerboard(across)',
        [PresetSubtype.Vertical]: 'checkerboard(down)',
    },

    [AnimType.CutIn]: {
        [PresetSubtype.Top]: 'wipe(down)',
        [PresetSubtype.Right]: 'wipe(left)',
        [PresetSubtype.Bottom]: 'wipe(up)',
        [PresetSubtype.Left]: 'wipe(right)',
    },
    [AnimType.CutOut]: {
        [PresetSubtype.Top]: 'wipe(up)',
        [PresetSubtype.Right]: 'wipe(right)',
        [PresetSubtype.Bottom]: 'wipe(down)',
        [PresetSubtype.Left]: 'wipe(left)',
    },

    [AnimType.EntrRandomBars]: {
        [PresetSubtype.Across]: 'randombar(horizontal)',
        [PresetSubtype.Vertical]: 'randombar(vertical)',
    },
    [AnimType.ExitRandomBars]: {
        [PresetSubtype.Across]: 'randombar(horizontal)',
        [PresetSubtype.Vertical]: 'randombar(vertical)',
    },

    [AnimType.EntrWipe]: {
        [PresetSubtype.Top]: 'wipe(up)',
        [PresetSubtype.Right]: 'wipe(right)',
        [PresetSubtype.Bottom]: 'wipe(down)',
        [PresetSubtype.Left]: 'wipe(left)',
    },
    [AnimType.ExitWipe]: {
        [PresetSubtype.Top]: 'wipe(up)',
        [PresetSubtype.Right]: 'wipe(right)',
        [PresetSubtype.Bottom]: 'wipe(down)',
        [PresetSubtype.Left]: 'wipe(left)',
    },

    [AnimType.EntrSplit]: {
        [PresetSubtype.VerticalIn]: 'barn(inVertical)',
        [PresetSubtype.HorizontalIn]: 'barn(inHorizontal)',
        [PresetSubtype.VerticalOut]: 'barn(outVertical)',
        [PresetSubtype.HorizontalOut]: 'barn(outHorizontal)',
    },
    [AnimType.ExitSplit]: {
        [PresetSubtype.VerticalIn]: 'barn(inVertical)',
        [PresetSubtype.HorizontalIn]: 'barn(inHorizontal)',
        [PresetSubtype.VerticalOut]: 'barn(outVertical)',
        [PresetSubtype.HorizontalOut]: 'barn(outHorizontal)',
    },

    [AnimType.EntrStrips]: {
        [PresetSubtype.TopRight]: 'strips(upRight)',
        [PresetSubtype.BottomRight]: 'strips(downRight)',
        [PresetSubtype.TopLeft]: 'strips(upLeft)',
        [PresetSubtype.BottomLeft]: 'strips(downLeft)',
    },
    [AnimType.ExitStrips]: {
        [PresetSubtype.TopRight]: 'strips(upRight)',
        [PresetSubtype.BottomRight]: 'strips(downRight)',
        [PresetSubtype.TopLeft]: 'strips(upLeft)',
        [PresetSubtype.BottomLeft]: 'strips(downLeft)',
    },

    [AnimType.EntrShapeCircle]: {
        [PresetSubtype.EleCenter]: 'circle(in)',
        [PresetSubtype.ToEleCenter]: 'circle(out)',
    },
    [AnimType.ExitShapeCircle]: {
        [PresetSubtype.EleCenter]: 'circle(in)',
        [PresetSubtype.ToEleCenter]: 'circle(out)',
    },

    [AnimType.EntrShapeBox]: {
        [PresetSubtype.EleCenter]: 'box(in)',
        [PresetSubtype.ToEleCenter]: 'box(out)',
    },
    [AnimType.ExitShapeBox]: {
        [PresetSubtype.EleCenter]: 'box(in)',
        [PresetSubtype.ToEleCenter]: 'box(out)',
    },

    [AnimType.EntrShapeDiamond]: {
        [PresetSubtype.EleCenter]: 'diamond(in)',
        [PresetSubtype.ToEleCenter]: 'diamond(out)',
    },
    [AnimType.ExitShapeDiamond]: {
        [PresetSubtype.EleCenter]: 'diamond(in)',
        [PresetSubtype.ToEleCenter]: 'diamond(out)',
    },

    [AnimType.EntrShapePlus]: {
        [PresetSubtype.EleCenter]: 'plus(in)',
        [PresetSubtype.ToEleCenter]: 'plus(out)',
    },
    [AnimType.ExitShapePlus]: {
        [PresetSubtype.EleCenter]: 'plus(in)',
        [PresetSubtype.ToEleCenter]: 'plus(out)',
    },

    [AnimType.EntrWheel]: {
        [PresetSubtype.Top]: 'wheel(1)',
        [PresetSubtype.Right]: 'wheel(2)',
        [PresetSubtype.TopRight]: 'wheel(3)',
        [PresetSubtype.Bottom]: 'wheel(4)',
        [PresetSubtype.Left]: 'wheel(8)',
    },
    [AnimType.ExitWheel]: {
        [PresetSubtype.Top]: 'wheel(1)',
        [PresetSubtype.Right]: 'wheel(2)',
        [PresetSubtype.TopRight]: 'wheel(3)',
        [PresetSubtype.Bottom]: 'wheel(4)',
        [PresetSubtype.Left]: 'wheel(8)',
    },
};
